import { Component, Input, OnInit } from '@angular/core';
import { MAT_MENU_DEFAULT_OPTIONS } from '@angular/material/menu';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'src/app/shared/services/cache/cache.service';
import { SELECTED_LANGUAGE_KEY } from 'src/app/types/constants';

@Component({
    selector: 'app-language-menu',
    templateUrl: './language-menu.component.html',
    styleUrls: ['./language-menu.component.sass'],
    standalone: false,
    providers: [
    {
      provide: MAT_MENU_DEFAULT_OPTIONS,
      useValue: {
        overlayPanelClass: ['dsr-menu-density-minus-4-overlay'],
      },
    },
  ],
})

export class LanguageMenuComponent implements OnInit {

  @Input() triggerSize = '2rem';
  @Input() itemFlagSize = '1.6rem';
  @Input() displayProperty: 'name' | 'code' = 'name';
  @Input() uppercase = false;

  currentLanguageIndex = 0;
  languages = [
    { image: 'assets/images/flags/flag_en.svg', name: 'English', code: 'en', flag: 'uk'},
    { image: 'assets/images/flags/flag_fr.svg', name: "Français", code: 'fr', flag: 'fr'}
  ];

  constructor(private translate: TranslateService, private cacheService: CacheService) { }

  ngOnInit() {
    this.currentLanguageIndex = this.languages.findIndex(language => language.code === this.translate.currentLang);
    if(this.currentLanguageIndex === -1) {
      this.currentLanguageIndex = 0; // Default to first language if not found
    }
    
    this.translate.onLangChange.subscribe((event: any) => {
      this.currentLanguageIndex = this.languages.findIndex(language => language.code === event.lang);
      if(this.currentLanguageIndex === -1) {
        this.currentLanguageIndex = 0; // Default to first language if not found
      }
    });
  }

  changeLanguage(index: number) {
    this.currentLanguageIndex = index;
    this.translate.use(this.languages[index].code);
    this.cacheService.setItem(SELECTED_LANGUAGE_KEY, this.languages[index].code);
  }

}